import React from 'react';
import { Route, Redirect, Switch } from 'react-router-dom';
import AppTemplate from 'components/base/template/AppTemplate';
import AppNav from 'components/base/nav/AppNav';
import PaymentContainer from 'containers/payment/PaymentContainer';

export default function Payment() {
  return <PaymentContainer />;
}
